// Rails UJS — handles data-method, data-confirm on links
import Rails from "@rails/ujs";
Rails.start();

// jQuery — expose globally for page-specific scripts and vendor plugins
// This must be imported before any plugin that checks window.jQuery
import "./jquery-global";

// Bootstrap 3 JS (requires jQuery global)
import "bootstrap-sass/assets/javascripts/bootstrap";

// Vendor jQuery plugins
import "../assets/javascripts/vendor/jquery.velocity.min";
import "../assets/javascripts/vendor/perfect-scrollbar-0.4.6.min";
import "../assets/javascripts/vendor/perfect-scrollbar-0.4.6.with-mousewheel.min";
import "../assets/javascripts/vendor/jquery.touchSwipe.min";
import "../assets/javascripts/vendor/jquery.scrollTo.min";
import "../assets/javascripts/vendor/jquery.priceformat.min.js";
import "../assets/javascripts/vendor/stacktable";

// Bootstrap Datepicker
import "bootstrap-datepicker";
import "bootstrap-datepicker/js/locales/bootstrap-datepicker.pt-BR";

// App modules
import "../assets/javascripts/modules/inspection_level";

// Main UI initialization (sidebar, nav, panels, etc.)
import "../assets/javascripts/vendor/main";

// App initialization (datepicker, price format, etc.)
import "../assets/javascripts/app";
